import type { ReactNode } from 'react';

import type { TextFieldConfig } from '../../config';
import type { SectionKey } from '../../lease-details.types';
import { LeaseTextInput } from '../../inputs/lease-text-input';
import { useFieldEventContextBuilder } from '../use-field-event-context';

export type TextFieldProps = {
  path: string;
  field: TextFieldConfig;
  sectionKey: SectionKey;
  arrayIndex?: number;
  required: boolean;
  disabled: boolean;
  label: ReactNode;
  helperText: ReactNode;
  errorHelperText: ReactNode;
};

export function TextField({
  path,
  field,
  sectionKey,
  arrayIndex,
  required,
  disabled,
  label,
  helperText,
  errorHelperText,
}: TextFieldProps) {
  const buildContext = useFieldEventContextBuilder<string>(path, sectionKey, arrayIndex);
  const handleBlur = (value: string | undefined) => {
    // Form state can be `undefined` (untouched) or `null` (seeded default);
    // coerce to '' so the callback receives the `FieldEventContext<string>`
    // its `TextFieldConfig` (extends FieldConfigBase<string>) type promises.
    field.events?.onBlur?.(buildContext(value ?? ''));
  };
  const handleChange = (value: string) => {
    field.events?.onChange?.(buildContext(value));
  };

  return (
    <LeaseTextInput
      name={path}
      title={typeof label === 'string' ? label : ''}
      placeholder={field.placeholder}
      helperText={helperText}
      errorHelperText={errorHelperText}
      required={required}
      disabled={disabled}
      type={field.inputType}
      onBlurValue={field.events?.onBlur ? handleBlur : undefined}
      onChangeValue={field.events?.onChange ? handleChange : undefined}
    />
  );
}
